import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { preloadSpaceRestrictionCheck } from '@confluence/restrictions/entry-points/preloadSpaceRestrictionCheck';

export const preloadCommonDataForRouteWithSpaceKey = async (spaceKey: string): Promise<any> => {
	return waitForAllReturnWhenError([preloadSpaceRestrictionCheck(spaceKey)]);
};
